import React, { useMemo } from 'react';
import isArray from 'lodash/isArray';

import './styles.css';

const CriteriaList = props => {
  const { records } = props;

  const FilterList = useMemo(
    () =>
      Object.values(records).map(record => ({
        ...record,
        groups: isArray(record.groups)
          ? record.groups
          : Object.values(record.groups),
      })),
    [records]
  );

  const getGroup = (group, title, key) => {
    const elements = isArray(group.elements)
      ? group.elements
      : Object.values(group.elements);

    return (
      <div className="criteria-list__group" key={key}>
        <div className="criteria-list__inner">
          <div className="criteria-list__title">{title}</div>
          {elements.length > 1 ? (
            <ul className="criteria-list__items">
              {elements.map((element, index) => (
                <li key={index} className="criteria-list__item">
                  {element}
                </li>
              ))}
            </ul>
          ) : (
            <span className="criteria-list__item criteria-list__item--single">
              {elements}
            </span>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="criteria-list">
      {FilterList.map(({ groups, title }, index) =>
        groups.length > 1
          ? groups.map((group, index) => getGroup(group, group.title, index))
          : getGroup(groups[0], title, index)
      )}
    </div>
  );
};

export default CriteriaList;
